var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 401.391,
    height: 463.488,
    viewBox: "0 0 401.391 463.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.697.576L.497 116.159v231.165l200.2 115.583 200.195-115.583V116.16z",
    fill: "none",
    stroke: "#00cd99",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00cd99",
    d: "M200.696.577v462.332M.5 116.16l400.391 231.166m0-231.166L.5 347.326"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.256 49.398L.5 213.801m400.391.001L116.136 49.398m200.195 346.749V67.339m-200.195 346.75l284.755-164.404m-400.391 0l284.756 164.403M85.061 67.341v328.806m.263-231.104H.5m400.392 0h-85.53M85.06 297.056H.5m400.391 0h-84.615",
    stroke: "#999",
    strokeDasharray: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.941 72.056)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.644,
    cy: 40.644,
    r: 40.644,
    transform: "translate(101.111 119.044)",
    fill: "#b0b4be"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cd99",
    d: "M115.636 267.023h52.237v52.237h-52.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a202b",
    d: "M151.635 283.26v19.762h-19.762V283.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cd99",
    d: "M115.636 0h52.237v52.237h-52.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#171c26",
    d: "M151.635 16.238V36h-19.762V16.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cd99",
    d: "M.001 66.807h52.237v52.237H.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a202b",
    d: "M35.999 83.044v19.764H16.237V83.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cd99",
    d: "M230.302 66.869h52.237v52.237h-52.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a202b",
    d: "M266.302 83.105v19.764H246.54V83.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cd99",
    d: "M0 200.21h52.237v52.237H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#171c26",
    d: "M36 216.447v19.762H16.238v-19.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cd99",
    d: "M231.272 198.882h52.237v52.237h-52.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#171c26",
    d: "M267.271 215.12v19.762h-19.762V215.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.211 141.563l-15.965 9.217v18.435l15.965 9.217 15.965-9.217v-18.431z",
    fill: "#1a202b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMain);
export default __webpack_public_path__ + "static/media/productMain.48df9d47fa55b7e5ce795025ca676f67.svg";
export { ForwardRef as ReactComponent };